export default __webpack_public_path__ + "static/media/pass-mob.dc647693.jpg";